
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta } from "/app/pages/[...slug].vue?macro=true";
import { default as component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta } from "/app/node_modules/.pnpm/nuxt@3.20.0_@parcel+watcher@2.5.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.22_db0@0.3.4_esli_mfn6ruyltul7hbkay32lah5rqm/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c } from "/app/node_modules/.pnpm/nuxt@3.20.0_@parcel+watcher@2.5.1_@types+node@24.10.0_@vue+compiler-sfc@3.5.22_db0@0.3.4_esli_mfn6ruyltul7hbkay32lah5rqm/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___cs",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "slug___cs",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta || {},
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_4565xuuMFULoZbO_183vt2UD8Meta || {},
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/cs",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en/cs",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/house-of-lobkowicz",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en/house-of-lobkowicz",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en/house-of-lobkowicz",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en/en/house-of-lobkowicz",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en/lobkowicz-palace-museum",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en/en/lobkowicz-palace-museum",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/index-sitemap.xml",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en/index-sitemap.xml",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/cs-sitemap.xml",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en/cs-sitemap.xml",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en-sitemap.xml",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  },
  {
    name: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8cMeta?.name,
    path: "/en/en-sitemap.xml",
    component: component_45stubp1bvOIZ8TydTzHyOPAVbsQrClb9d_6_LExiGxcOII8c
  }
]